// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ERa9","bigColWidth":"Table_bigColWidth__2UYKU","biggerColWidth":"Table_biggerColWidth__2TdzG","row":"Table_row__1L-78","col":"Table_col__3oAJ1"};